import { render, staticRenderFns } from "./ShippingTipsNotification.vue?vue&type=template&id=1f5ecad2"
import script from "./ShippingTipsNotification.vue?vue&type=script&lang=ts"
export * from "./ShippingTipsNotification.vue?vue&type=script&lang=ts"
import style0 from "./ShippingTipsNotification.vue?vue&type=style&index=0&id=1f5ecad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports